import { ColumnLayout } from 'product-card/types'

import type { ColumnsNumber } from '../types/Options'

export const PLP_USER_COLUMNS = 'plp-user-columns'
export const PLP_LARGE_USER_COLUMNS = 'large-columns'
export const PLP_SMALL_USER_COLUMNS = 'small-columns'

export const SMALL = 'small'
export const LARGE = 'large'

export const MAX_COLUMNS = 4

export const DEFAULT_COLUMNS_SMALL = ColumnLayout.OneColumn
export const DEFAULT_COLUMNS_LARGE = ColumnLayout.FourColumns

export const GRID_COLUMNS_VALUES: { [x: number]: string } = {
	1: '100%',
	2: '50%',
	4: '25%',
}

export interface ColumnUserStore {
	[PLP_SMALL_USER_COLUMNS]: ColumnsNumber
	[PLP_LARGE_USER_COLUMNS]: ColumnsNumber
}

export const defaultStore: ColumnUserStore = {
	[PLP_SMALL_USER_COLUMNS]: DEFAULT_COLUMNS_SMALL,
	[PLP_LARGE_USER_COLUMNS]: DEFAULT_COLUMNS_LARGE,
}

/**
 * This object stabilizes the behavior of the "provisional responsive" grid
 */
export const responsiveBehavior = {
	small: {
		[ColumnLayout.OneColumn]: ColumnLayout.OneColumn,
		[ColumnLayout.TwoColumns]: ColumnLayout.OneColumn,
		[ColumnLayout.FourColumns]: ColumnLayout.TwoColumns,
	},
	large: {
		[ColumnLayout.OneColumn]: ColumnLayout.TwoColumns,
		[ColumnLayout.TwoColumns]: ColumnLayout.FourColumns,
		[ColumnLayout.FourColumns]: ColumnLayout.FourColumns,
	},
}

export function getDefaultStorageIndex(isSmall: boolean) {
	return isSmall ? PLP_SMALL_USER_COLUMNS : PLP_LARGE_USER_COLUMNS
}
